import { message } from 'antd';
import axios from 'axios';
// import { getShopId, getToken } from '@/config/request/interceptors';
import { serviceConfig } from '@/config/request/swaggerServiceConfig';

//   getExchange().then((res) => {
//     rate.value = res.data?.exchangeRate
//     floatingRate.value = Number(res.data?.exchangeRate) + 1
//   })

// const req = () => {
//   if (store?.state.route?.user?.mainCustomerId) {
//     getFloatExchange(store.state.route?.user?.mainCustomerId).then((res) => {
//       rate.value = res.data?.originalExchangeRate
//       floatingRate.value = res.data?.exchangeRate
//       floatExchangeRate.value = res.data?.floatExchangeRate
//     })
//   } else {
//     getExchange().then((res) => {
//       rate.value = res.data?.exchangeRate
//       floatingRate.value = Number(res.data?.exchangeRate) + 1
//     })
//   }
// }

// // 半小时获取一次汇率
// setInterval(() => {
//   req()
// }, 1000 * 1800)

export const getToken = () => {
    const tokenStr = window.localStorage.getItem('production_route/token');
    if (!tokenStr) return;
    try {
        const token = JSON.parse(tokenStr).val;
        return token;
    } catch (e) {
        return undefined;
    }
};
const axiosRequest = axios.create({
    baseURL: serviceConfig.baseURL,
    headers: {
        'X-Authtoken': getToken() ?? '',
        'X-Stationcode': localStorage.getItem('stationCode'),
        'X-GRAY-TAG': process.env.REACT_APP_X_GRAY_TAG,
        'X-Appname': 'ckb-oem-client'
    }
});

axiosRequest.interceptors.response.use(
    function (response) {
        if (response.data.success === true) return response;
        message.error(response.data.msg);
        return Promise.reject(response.data.msg);
    },
    function (error) {
        message.error('请求错误：' + String(error));
        return Promise.reject(error);
    }
);

/** 浮动汇率 */
export const getFloatExchange = (data) => {
    const { mainCustomerId, currencyCode = 'CNY' } = data;
    return axiosRequest({
        url: `/settlement/exchangeRate/cnyToJpyExchangeRateAfterConfigFloat?mainCustomerId=${mainCustomerId}&currencyCode=${currencyCode}`,
        method: 'GET'
    });
};
/** 未登录时获取汇率的接口 */
export const getOriginExchangeRate = (data) => {
    const { stationCode, currencyCode = 'CNY' } = data;
    return axiosRequest({
        url: `/settlement/exchangeRate/getOriginExchangeRate?stationCode=${stationCode}&currencyCode=${currencyCode}`,
        method: 'GET'
    });
};

export const getExchange = (data) => {
    return axiosRequest({
        url: '/settlement/exchangeRate/getLatestExchangeRate',
        method: 'GET',
        data: {
            currencyCodeFrom: 'CNY',
            currencyCodeTo: 'JPY'
        }
    });
};
